export default "__VITE_ASSET__CnzyYeGW__"